<div class="container d-flex justify-content-between align-items-center" style="margin-top: 30px">
    <!-- <app-linker-route [headingName]="headingName" [linkerRouteItems]="linkerRouteItems" style="margin-top: -20px">
    </app-linker-route> -->

    <div class="row">
        <div class="form-group has-search mb-0">
            <span class="fa fa-search form-control-feedback"></span>
            <input type="text" class="form-control" [(ngModel)]="serviceName" placeholder="Search by product name"
                (input)="getServiceList(); currentPage = 1" (input)="!serviceName && getServiceList()" />
        </div>
    </div>
</div>
<div class="container mb-5 wrapper-content mt-3" style="padding-left: 0px">
    <sub-category-filter (onSelectCategory)="getsubCatId($event)"></sub-category-filter>

    <!-- Product Grid Section -->
    <div class="product-grid-section">
        <div class="product-grid">
            <ng-container *ngIf="productDetails?.length">
                <div
                    class="product-card"
                    *ngFor="
                        let item of productDetails
                            | paginate
                                : {
                                    itemsPerPage: pageSize,
                                    currentPage: currentPage,
                                    totalItems: totalItems
                                };
                        let i = index
                    "
                    (click)="navigateToViewProduct(item?._id)"
                >
                    <div class="product-image-container">
                        <img [src]="item?.thumbnail" [alt]="item?.productName" class="product-image" />
                        <div class="discount-badge" *ngIf="getOriginalPrice(item) && getOriginalPrice(item) !== getDisplayPrice(item)">{{ getDiscountPercentage(item) }}% OFF</div>
                        <button class="favorite-btn" (click)="addWishlist(item?._id, $event)" [class.active]="item?.isLike">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
                            </svg>
                        </button>
                    </div>
                    <div class="product-info">
                        <!-- <div class="product-brand">{{ item?.brand || 'BRAND' }}</div> -->
                        <div class="product-subcategory mb-1" *ngIf="item?.subCategoryId?.subCategoryName">
                            {{ item?.subCategoryId?.subCategoryName }}
                        </div>
                        <h3 class="product-name">{{ item?.productName }}</h3>
                        <p class="product-description">{{ item?.description || 'Premium quality product with modern design and excellent features.' }}</p>
                        <div class="product-price">
                            <span class="current-price">{{ getDisplayPrice(item) }}</span>
                            <span class="original-price" *ngIf="getOriginalPrice(item)">{{ getOriginalPrice(item) }}</span>
                        </div>
                        <div class="product-actions">
                            <button class="add-to-cart-btn add-to-cart-btn--wide">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-right: 8px;">
                                    <path d="M3 4H5.2C5.57 4 5.89 4.25 5.97 4.6L7.34 10.52C7.56 11.47 8.41 12.15 9.38 12.15H16.88C17.79 12.15 18.6 11.56 18.88 10.69L20.5 5.74C20.72 5.05 20.21 4.35 19.5 4.35H6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <circle cx="10" cy="18" r="1" fill="currentColor"/>
                                    <circle cx="17" cy="18" r="1" fill="currentColor"/>
                                </svg>
                                ADD TO CART
                            </button>
                        </div>
                    </div>
                </div>
            </ng-container>
            
            <!-- Loading State -->
            <ng-container *ngIf="!productDetails?.length && !apiLoaded">
                <div class="product-card loading-card" *ngFor="let item of length(12)">
                    <div class="loading-image">
                        <div class="skeleton-loader"></div>
                    </div>
                    <div class="loading-title">
                        <div class="skeleton-text"></div>
                    </div>
                </div>
            </ng-container>
            
            <!-- No Data State -->
            <div *ngIf="apiLoaded && !productDetails?.length" class="no-data-state">
                <img src="assets/images/notfound.png" alt="No Data Found" class="notfound-img" />
                <p>No Data Found</p>
            </div>
        </div>
    </div>
    <div class="pagination-section" *ngIf="getTotalPages() > 1 && productDetails?.length">
        <div class="pagination-controls">
            <button
                class="pagination-btn prev-btn"
                [disabled]="currentPage === 1"
                (click)="goToPage(currentPage - 1)"
                [class.disabled]="currentPage === 1"
            >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>

            <button
                *ngFor="let page of getPageNumbers()"
                class="pagination-btn page-btn"
                [class.active]="page === currentPage"
                (click)="goToPage(page)"
            >
                {{ page }}
            </button>

            <button
                class="pagination-btn next-btn"
                [disabled]="currentPage === getTotalPages()"
                (click)="goToPage(currentPage + 1)"
                [class.disabled]="currentPage === getTotalPages()"
            >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
        </div>
    </div>
</div>